var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0 pb-O",attrs:{"fluid":""}},[(_vm.exerciseID && _vm.formationID)?_c('ExerciceComponent',{attrs:{"idExercice":_vm.exerciseID,"idFormation":_vm.formationID}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }